import React from 'react'
import PropTypes from 'prop-types'

import { ResizeContext } from 'contexts/Resize'

import IconBlock from './IconBlock'
import {
  Wrapper,
  Container,
  TextBlock,
  Title,
  Description,
  ImageBlock,
  Image,
  RightIcons,
  LeftIcons,
} from './styles'
import bg from './assets/image.png'
import bg_mob from './assets/image_mob.png'

export const BKeyFactors = ({ texts }) => {
  const { mobile, tablet } = React.useContext(ResizeContext)

  const { title, description, icons } = texts

  return (
    <Wrapper>
      <Container>
        <TextBlock>
          <Title
            weight={'medium'}
            size={['50/60', '50/60', '35/40']}
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <Description
            size={['22/30', '22/30', '16/25']}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </TextBlock>

        <ImageBlock>
          <RightIcons>
            {icons.slice(0, 3).map(item => (
              <IconBlock key={item.icon} icon={item.icon} title={item.title} />
            ))}
          </RightIcons>

          <Image
            src={(mobile || tablet) ? bg_mob : bg}
            alt={'image-belly'}
          />

          <LeftIcons>
            {icons.slice(3, 6).map(item => (
              <IconBlock key={item.icon} icon={item.icon} title={item.title} />
            ))}
          </LeftIcons>
        </ImageBlock>

      </Container>
    </Wrapper>
  )
}

BKeyFactors.propTypes = {
  texts: PropTypes.object.isRequired,
}
